<span class="component-container facilities-container bk-page-break">
  <app-section-header
    [title]="'facilities-data.exhaust-title' | translate"
    [tooltip]="'tooltips.facilities-data.exhaust' | translate"></app-section-header>
</span>
<span class="component-container base-data-container">
  <form [formGroup]="exhaustSystemFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
    <div class="form-background">
      <div class="ui-g-12 checkbox-rows">
        <div
          [class]="i === 3 ? 'ui-g-6' : 'ui-g-2'"
          [style.display]="i === 3 ? 'flex' : 'block'"
          *ngFor="let data of exhaustCheckboxLabels | slice : 0 : 4; let i = index">
          <p-checkbox
            [readonly]="isReadOnly"
            binary="true"
            [formControlName]="data.controlName"
            id="{{ data.label }}"
            [label]="getCheckBoxLabel(data.label) | translate"></p-checkbox>
          <label
            for="{{ data.label }}"
            [class.required]="exhaustSystemFG.get('systemUsabilityCheckbox').value && i === 3"
            [class]="i !== 3 ? 'ui-g-5' : null"></label>
          <input
            [readonly]="isReadOnly"
            *ngIf="i === 3 && exhaustSystemFG.get('systemUsabilityCheckbox').value"
            class="system-usability"
            id="exhaust"
            formControlName="systemUsabilityTextValue"
            pInputText />
        </div>
      </div>
      <div class="ui-g-12 checkbox-rows">
        <div class="ui-g-2" *ngFor="let data of exhaustCheckboxLabels | slice : 4 : 6; let i = index">
          <p-checkbox
            [readonly]="isReadOnly"
            binary="true"
            [formControlName]="data.controlName"
            id="{{ data.label }}"
            [label]="getCheckBoxLabel(data.label) | translate"></p-checkbox>
          <label for="{{ data.label }}" class="ui-g-5"></label>
        </div>
      </div>
      <div class="ui-g-12 checkbox-rows">
        <div [class]="i === 1 ? 'ui-g-4' : 'ui-g-2'" *ngFor="let data of exhaustCheckboxLabels | slice : 6 : 8; let i = index">
          <p-checkbox
            [readonly]="isReadOnly"
            binary="true"
            [formControlName]="data.controlName"
            id="{{ data.label }}"
            [label]="getCheckBoxLabel(data.label) | translate"></p-checkbox>
          <label for="{{ data.label }}" class="ui-g-5"></label>
        </div>
      </div>
      <div class="ui-g-12 checkbox-rows">
        <div
          [class]="i === 1 ? 'ui-g-4' : i === 2 ? 'ui-g-6' : 'ui-g-2'"
          *ngFor="let data of exhaustCheckboxLabels | slice : 8 : 11; let i = index">
          <p-checkbox
            [readonly]="isReadOnly"
            binary="true"
            [formControlName]="data.controlName"
            id="{{ data.label }}"
            [label]="getCheckBoxLabel(data.label) | translate"></p-checkbox>
          <label for="{{ data.label }}" class="ui-g-5"></label>
        </div>
      </div>
      <table class="form-section">
        <tr>
          <th></th>
          <th>{{ 'facilities-data.form-fields.buildingMaterial' | translate }}</th>
          <th>{{ 'facilities-data.form-fields.thicknessInCm' | translate }}</th>
          <th>{{ 'facilities-data.form-fields.producerType' | translate }}</th>
          <th>{{ 'facilities-data.form-fields.proofOfUsability' | translate }}</th>
        </tr>
        <tr *ngFor="let data of tableData; let i = index">
          <td>{{ getTableLabel(data['key']) | translate }}</td>
          <td *ngFor="let d of data['value']; let i = index" [formGroupName]="data['key']">
            <input [readonly]="isReadOnly" *ngIf="i === 0" class="text-width" type="text" [formControlName]="d['key']" pInputText />
            <input
              [readonly]="isReadOnly"
              [appNumber]="true"
              *ngIf="i === 1 && data['key'] !== 'shaft'"
              class="text-width"
              type="text"
              [formControlName]="d['key']"
              pInputText />
            <p-dropdown
              [readonly]="isReadOnly"
              *ngIf="i === 1 && data['key'] === 'shaft'"
              [options]="outerShellThicknessOptions"
              [formControlName]="d['key']"
              id="exhaust-{{ i }}"
              placeholder="-Select-"
              styleClass="netz-small-dropdown">
              <ng-template let-item pTemplate="selectedItem">
                <span class="drop-item-label">
                  {{ 'lookup.' + outerShellThickness + '.options.' + item['value'] + '.name' | translate }}
                </span>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="drop-item">
                  <span class="drop-item-label">
                    {{ 'lookup.' + outerShellThickness + '.options.' + option['value'] + '.name' | translate }}
                  </span>
                </div>
              </ng-template>
            </p-dropdown>
            <input [readonly]="isReadOnly" *ngIf="i > 1" class="text-width" type="text" [formControlName]="d['key']" pInputText />
          </td>
        </tr>

        <tr>
          <td>{{ 'facilities-data.form-fields.effective-height' | translate }}</td>
          <td>
            <input
              [readonly]="isReadOnly"
              appFloatNumber="2"
              class="small-width"
              id="effective-height"
              formControlName="effectiveHeight"
              pInputText />
            <span class="margin">m</span>
          </td>
          <td>
            {{ 'facilities-data.form-fields.fireplace' | translate }}
          </td>
        </tr>

        <tr>
          <td>{{ 'facilities-data.form-fields.chimney' | translate }}</td>
          <td>
            <input [readonly]="isReadOnly" type="text" class="small-width" id="chimney" formControlName="chimney" pInputText />
          </td>
          <td>
            <p-dropdown
              [readonly]="isReadOnly"
              [options]="pipeUnitOptions"
              formControlName="fireplace"
              id="fireplace"
              placeholder="-Select-"
              styleClass="netz-small-dropdown">
              <ng-template let-item pTemplate="selectedItem">
                <span class="drop-item-label">{{ 'lookup.' + pipeUnit + '.options.' + item['value'] + '.name' | translate }}</span>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="drop-item">
                  <span class="drop-item-label">{{ 'lookup.' + pipeUnit + '.options.' + option['value'] + '.name' | translate }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </td>
        </tr>
      </table>

      <div class="ui-g form-row">
        <div class="ui-g-2">{{ 'facilities-data.form-fields.dimension' | translate }} :</div>
        <div class="ui-g-4 field-cols">
          <div class="field-row" *ngFor="let assessment of assessmentBaseOptions; let i = index">
            <p-radioButton
              name="construction_chimney"
              [value]="assessment.value"
              formControlName="dimension"
              class="p-field-radio"
              labelStyleClass="radio-label"
              [labelStyleClass]="exhaustSystemFG.get('dimension').value === 'din' && assessment.value === 'din' ? 'required' : ''"
              [label]="getDimensionRadioLabels(assessment.value) | translate"></p-radioButton>
            <input
              [readonly]="isReadOnly"
              *ngIf="i === 1"
              type="text"
              class="din-width din-margin"
              id="din"
              formControlName="din"
              pInputText />
          </div>
        </div>
      </div>
    </div>
  </form>
</span>
